import React, { useState } from 'react';
import SwitchAccountIcon from '@mui/icons-material/SwitchAccount';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { useDispatch, useSelector } from 'react-redux';
import { ArrowBackIos, Tune, PendingActions, Login } from '@mui/icons-material';
import { Badge, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Header } from '../../components/header/header';
import Strings from '../../i18n';
import { UsersTemplate } from '../../templates/usersTemplate/usersTemplate';
import { ButtonIconStyled } from './usersViewStyles';
import { viewRightSideBarEnum } from '../../constants/sidebarEnums';
import { selectCurrentUser } from '../../store/slices/login/login';
import {
  systemModuleEnum,
  systemModulePermissionsEnum
} from '../../constants/systemRolesEnums';
import { setPermissionsReadWriteSystemUsers } from '../../store/slices/systemPermissions/systemPermissions';
import {
  StyledHeaderContainer,
  StyledTitleHeader
} from '../../components/layout/main/mainStyles';
import { IUserInfo } from '../../types/Auth/authInterface';
import { ReOpenSideBarIcon } from '../../components/commons/reOpenSideBarIcon/reOpenSideBarIcon';

export const UsersView = () => {
  const dispatch = useDispatch();
  const [selectedUsers, setSelectedUsers] = useState<IUserInfo[]>([]);
  const [openSideBar, setOpenSideBar] = useState(false);
  const [reloadTableHandler, setReloadTableHandler] = useState(false);
  const queryParams = new URLSearchParams(window.location.search);
  const filtersCount = Array.from(queryParams.keys()).length;
  const navigate = useNavigate();

  const [sideBarOpenFor, setSideBarOpenFor] = useState(
    viewRightSideBarEnum.editUserPermissions
  );

  const openRightSideBarForMethod = (method: number) => {
    setSideBarOpenFor(method);
    setOpenSideBar(true);
  };

  const contextUser = useSelector(selectCurrentUser);

  const modulePermissions = contextUser.roleInfo.permissionsByModule.find(
    (module) => module.systemModuleName === systemModuleEnum.users
  );

  const permissionReadWrite = !!modulePermissions?.permissions.includes(
    systemModulePermissionsEnum.readWrite
  );

  dispatch(setPermissionsReadWriteSystemUsers(permissionReadWrite));

  return (
    <div>
      <Header>
        <StyledHeaderContainer>
          <div className="row justify-content-between">
            <div className="col-1 col-sm-4 text-left">
              <ButtonIconStyled size="small" onClick={() => navigate(-1)}>
                <ArrowBackIos />
              </ButtonIconStyled>
            </div>
            <div className="col-4 text-center">
              <StyledTitleHeader>{Strings.users.users}</StyledTitleHeader>
            </div>
            <div className="col-8 col-sm-4 col-md-4 text-right">
              {permissionReadWrite ? (
                <>
                  <Tooltip title={Strings.users.addUser}>
                    <ButtonIconStyled
                      size="small"
                      onClick={() => {
                        openRightSideBarForMethod(
                          viewRightSideBarEnum.addSystemUser
                        );
                      }}
                    >
                      <PersonAddAltIcon />
                    </ButtonIconStyled>
                  </Tooltip>
                  <Tooltip title={Strings.users.addAdmin}>
                    <ButtonIconStyled
                      disabled
                      size="small"
                      onClick={() => {
                        openRightSideBarForMethod(
                          viewRightSideBarEnum.addAdmin
                        );
                      }}
                    >
                      <AdminPanelSettingsIcon />
                    </ButtonIconStyled>
                  </Tooltip>
                  <Tooltip title={Strings.users.addRole}>
                    <ButtonIconStyled
                      size="small"
                      onClick={() => {
                        openRightSideBarForMethod(
                          viewRightSideBarEnum.manageUserRoles
                        );
                      }}
                    >
                      <AddCircleOutlineIcon />
                    </ButtonIconStyled>
                  </Tooltip>
                  <Tooltip title={Strings.users.addRole}>
                    <ButtonIconStyled
                      disabled
                      size="small"
                      onClick={() => {
                        openRightSideBarForMethod(
                          viewRightSideBarEnum.editUserPermissions
                        );
                      }}
                    >
                      <AccountCircleIcon />
                    </ButtonIconStyled>
                  </Tooltip>
                </>
              ) : null}
              <Tooltip title={Strings.users.filters}>
                <ButtonIconStyled
                  size="small"
                  onClick={() => {
                    openRightSideBarForMethod(viewRightSideBarEnum.filters);
                  }}
                >
                  <Badge badgeContent={filtersCount} color="warning">
                    <Tune />
                  </Badge>
                </ButtonIconStyled>
              </Tooltip>
              <Tooltip title={Strings.users.newAccountCodes}>
                <ButtonIconStyled
                  size="small"
                  onClick={() => {
                    navigate('/users/pending/activation');
                  }}
                >
                  <PendingActions />
                </ButtonIconStyled>
              </Tooltip>
              <Tooltip title={Strings.users.accountLoginCode}>
                <ButtonIconStyled
                  size="small"
                  onClick={() => {
                    navigate('/users/login/code');
                  }}
                >
                  <Login />
                </ButtonIconStyled>
              </Tooltip>

              <ReOpenSideBarIcon
                isOpenRightSideBar={openSideBar}
                selectedItems={selectedUsers}
                singleItemMethod={() => {
                  openRightSideBarForMethod(
                    viewRightSideBarEnum.editUserAndRole
                  );
                }}
                multipleItemsMethod={() => {
                  openRightSideBarForMethod(
                    viewRightSideBarEnum.editMultipleUsers
                  );
                }}
              />
              <Tooltip title={Strings.userProfile.resetPasswordUrl}>
                <ButtonIconStyled
                  size="small"
                  onClick={() => {
                    navigate('/reset-password-report');
                  }}
                >
                  <SwitchAccountIcon />
                </ButtonIconStyled>
              </Tooltip>
            </div>
          </div>
        </StyledHeaderContainer>
      </Header>
      <UsersTemplate
        sideBarOpenFor={sideBarOpenFor}
        openRightSideBarForMethod={openRightSideBarForMethod}
        setOpenSideBar={setOpenSideBar}
        openedSideBar={openSideBar}
        selectedUsers={selectedUsers}
        setSelectedUsers={setSelectedUsers}
        reloadTableHandler={reloadTableHandler}
        setReloadTableHandler={setReloadTableHandler}
      />
    </div>
  );
};
